// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1h6SD","clinicsSelect":"TableHeading_clinicsSelect__1FjuT"};